export default __webpack_public_path__ + "static/icon-32-5-e699f6a8eb4679f05e93336e38da51f4.png";